import { Box, Typography } from "@mui/material";

import { EditableRoutePoint } from "./components";

import type { SearchBoxFeatureSuggestion } from "@mapbox/search-js-core";

const STOP_LABELS: Record<string, string> = {
  ORIGIN: "Origin (Pickup)",
  DESTINATION: "Destination (Drop Off)",
  MID: "Stop",
};

function getStopLabel(
  routePoint: EditableRoutePointState,
  index: number,
): string {
  const stopType = routePoint.stop_type ?? "MID";
  return `${index + 1}. ${STOP_LABELS[stopType] ?? "Stop"}`;
}

interface Props {
  index: number;
  routePoint: EditableRoutePointState;
  onRoutePointTimeChange: (key: "start_time", value: string) => void;
  onAddressSuggestionSelected: (feature: SearchBoxFeatureSuggestion) => void;
  onAddressCleared: () => void;
  deleteMidRoutePointButton: React.ReactNode;
  handleRoutePointLocationValueChange: <T>(
    key: keyof RoutePointLocation,
    value: T | null,
    index: number,
  ) => void;
  updateInputModeForRoutePoint: (
    index: number,
    mode: "autocomplete" | "manual",
  ) => void;
  onSetRoutePointBeingEdited: (index: number, edit: boolean) => void;
  onScheduleTypeUpdate: (value: RoutePointScheduleType) => void;
}

export function RoutePoint(props: Props) {
  const {
    routePoint,
    onRoutePointTimeChange,
    onAddressSuggestionSelected,
    onAddressCleared,
    deleteMidRoutePointButton,
    handleRoutePointLocationValueChange,
    index,
    updateInputModeForRoutePoint,
    onSetRoutePointBeingEdited,
    onScheduleTypeUpdate,
  } = props;

  const handleAddressSuggestionSelected = (
    feature: SearchBoxFeatureSuggestion,
  ) => {
    onAddressSuggestionSelected(feature);
    onSetRoutePointBeingEdited(index, false);
  };

  return (
    <Box
      sx={{
        position: "relative",
        border: "1px solid",
        borderColor: "grey.300",
        borderRadius: 1,
        p: 2,
        pt: 3,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          top: -10,
          left: 10,
          bgcolor: "background.paper",
          px: 0.5,
          color: "text.secondary",
          lineHeight: 1.5,
        }}
      >
        {getStopLabel(routePoint, index)}
      </Typography>
      <EditableRoutePoint
        index={index}
        handleRoutePointLocationValueChange={
          handleRoutePointLocationValueChange
        }
        updateInputModeForRoutePoint={updateInputModeForRoutePoint}
        routePoint={routePoint}
        onRoutePointTimeChange={onRoutePointTimeChange}
        onAddressSuggestionSelected={handleAddressSuggestionSelected}
        onAddressCleared={onAddressCleared}
        deleteMidRoutePointButton={deleteMidRoutePointButton}
        onScheduleTypeUpdate={onScheduleTypeUpdate}
      />
    </Box>
  );
}
